import instObj from '@/backend/axios-instances'

const resource = "/productmaster"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    // need product_type_id and product_category_id as a param
    return instance.post(resource, data, { params: parameters });
  }
}
